


























































































































































































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { Department } from '@/model/companyStructure/Department'
import { GridOptions } from '@/types'
import QcqShiftPlanningGroupEditorDialog from '@/components/master-data/shifts/QcqShiftPlanningGroupEditorDialog.vue'
import QcqShiftOffsetEditorDialog from '@/components/master-data/shifts/QcqShiftOffsetEditorDialog.vue'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import ColorPicker from '@/components/ColorPicker.vue'
import { Color } from '@/types'
import { QcqShift } from '@/model/master-data/QcqShift'
import { QcqShiftPlanningGroup } from '@/model/master-data/QcqShiftPlanningGroup'
import { MasterDataActionsEnum, QcqOperations } from '@/types/enums'
import { QcqShiftCompetences } from '@/model/master-data/QcqShiftCompetences'
import DeleteDialog from '@/components/DeleteDialog.vue'
import CommentCellRenderer from '@/components/cell-renderer/CommentCellRenderer.vue'
import QcqShiftBreakDialog from '@/components/master-data/shifts/QcqShiftBreakDialog.vue'
import { ShiftBreak } from '@/model/master-data/ShiftBreak'
import { ShiftBreakPayload } from '@/types/payload'
import { hexToRgba } from '@/services/hex-to-rgba'
import QcqQualityStarsSelector from '@/components/master-data/shifts/QcqQualityStarsSelector.vue'

interface ComponentData {
  planningGroupGridOptions: GridOptions
  offsetGridOptions: GridOptions
  showPlanningGroupDialog: boolean
  selectedAddedPlanningGroup: any
  showOffsetDialog: boolean
  showErrorSnackbar: boolean
  errorMessage: string
  isEnableOffsetButtons: boolean
  showDeletePlanningGroupDialog: boolean
  showDeleteOffsetDialog: boolean
  selectedAddedOffset: QcqShiftCompetences | undefined
  codeValidationRules: Array<Function>
  descriptionValidationRules: Array<Function>
  startValidationRules: Array<Function>
  endValidationRules: Array<Function>
  departmentValidationRules: Array<Function>
  formData: QcqShift | undefined
  planningGroupAction: QcqOperations | undefined
  currentSelectedPlanningGroupId: string
  planningGroupDialogTitle: string
  overlayNoRowsTemplate: string
  gridFrameworkComponents: Object
  breakGridOptions: GridOptions
  selectedBreakData: ShiftBreak | undefined
  currentSelectedBreakId: string | undefined
  showBreakDialog: boolean
  breakDialogTitle: string
  showDeleteBreakDialog: boolean
  offsetAction: QcqOperations | undefined
}

export default Vue.extend({
  name: 'QcqShiftsEditorDialog',

  components: {
    AgGridVue,
    QcqShiftPlanningGroupEditorDialog,
    QcqShiftOffsetEditorDialog,
    ColorPicker,
    DeleteDialog,
    QcqShiftBreakDialog
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    departmentList: {
      type: Array as () => Array<Department>
    },

    allPlanningGroupList: {
      type: Array as () => Array<PlanningGroup>
    },

    selectedDepartmentId: {
      type: Number
    },

    dialogData: {
      type: QcqShift
    },

    loading: {
      type: Boolean
    },

    title: String,
    action: String,
    maxStars: Number
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.shifts.required').toString()

    return {
      planningGroupGridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.shifts.planningGroup'), field: 'planningGroupName' },
          { headerName: this.$t('masterData.shifts.numberOfEmployees'), field: 'numberOfEmployees' },
          { headerName: this.$t('masterData.shifts.offset'), field: 'offset', width: 100 },
          { headerName: this.$t('masterData.shifts.comment'), field: 'comment', width: 535, cellRenderer: 'commentCellRenderer' },
        ]
      },

      gridFrameworkComponents: {
        commentCellRenderer: CommentCellRenderer,
        starsCellRenderer: QcqQualityStarsSelector
      },

      offsetGridOptions: {
        columnDefs: [
          { headerName: this.$t('qcqDialogComponent.offset'), field: 'offset' },
          { headerName: this.$t('qcqDialogComponent.work'), field: 'displayLabel' },
          { headerName: this.$t('qcqDialogComponent.competence'), field: 'competencesDescription' },
          {
            headerName: this.$t('qcqDialogComponent.quality'),
            field: 'quality',
            cellRenderer: 'starsCellRenderer',
            width: 230,
            //@ts-ignore
            cellRendererParams: {
              maxStars: this.maxStars
            },
          },
          { headerName: this.$t('qcqDialogComponent.educationDegree'), field: 'educationLevelDescription' },
          { headerName: this.$t('qcqDialogComponent.job'), field: 'jobDescription' },
          { headerName: this.$t('qcqDialogComponent.subjectArea'), field: 'specializationDescription' },
          { headerName: this.$t('qcqDialogComponent.details'), field: 'detailsDescription' },
        ]
      },

      showPlanningGroupDialog: false,
      selectedAddedPlanningGroup: undefined,
      showOffsetDialog: false,
      showErrorSnackbar: false,
      errorMessage: '',
      codeValidationRules: [
        required
      ],
      descriptionValidationRules: [
        required
      ],
      startValidationRules: [
        required
      ],
      endValidationRules: [
        required
      ],
      departmentValidationRules: [
        required
      ],
      isEnableOffsetButtons: false,
      showDeletePlanningGroupDialog: false,
      showDeleteOffsetDialog: false,
      selectedAddedOffset: undefined,
      formData: undefined,
      planningGroupAction: undefined,
      currentSelectedPlanningGroupId: '',
      planningGroupDialogTitle: '',
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      breakGridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.shifts.start'), field: 'startBreak', width: 100 },
          { headerName: this.$t('masterData.shifts.end'), field: 'endBreak', width: 100 },
          { headerName: this.$t('masterData.shifts.duration'), field: 'duration', width: 100 },
          { headerName: this.$t('masterData.shifts.capacityDeduction'), field: 'deductionCapacity'},
          { headerName: this.$t('masterData.shifts.comment'), field: 'comment', cellRenderer: 'commentCellRenderer', width: 535 },
        ]
      },
      selectedBreakData: undefined,
      currentSelectedBreakId: undefined,
      showBreakDialog: false,
      breakDialogTitle: '',
      showDeleteBreakDialog: false,
      offsetAction: undefined
    }
  },

  computed: {
    isEnableBreakButtons (): boolean {
      return !!this.currentSelectedBreakId
    },

    isAddPlanningGroupEnabled (): boolean {
      return !!this.selectedDepartmentId
    },

    isEnableButtons (): boolean {
      return !!this.currentSelectedPlanningGroupId
    },

    isAddOffsetEnabled (): boolean {
      if (this.formData && this.selectedAddedPlanningGroup && this.currentSelectedPlanningGroupId) {
        let foundCompetences: Array<QcqShiftCompetences> = this.formData.competences.filter(
          (item: QcqShiftCompetences) => item.planningGroup === this.selectedAddedPlanningGroup.planningGroup)
        if (this.selectedAddedPlanningGroup.numberOfEmployees > foundCompetences.length) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },

    filteredPlanningGroupList (): Array<PlanningGroup> {
      let filteredPlanningGroup: Array<PlanningGroup>
      if (this.formData && this.planningGroupAction === QcqOperations.ADD) {
        filteredPlanningGroup = _.differenceBy(this.allPlanningGroupList, this.formData.planningGroupList, 'planningGroup')
        return filteredPlanningGroup
      } else if (this.formData && this.allPlanningGroupList && this.planningGroupAction === QcqOperations.EDIT) {
        filteredPlanningGroup = _.differenceBy(this.allPlanningGroupList, this.formData.planningGroupList, 'planningGroup')
        let selectedPlanningGroup: PlanningGroup | undefined = this.allPlanningGroupList.find((item: PlanningGroup) =>
          item.planningGroup === this.selectedAddedPlanningGroup.planningGroup && item.department === this.selectedAddedPlanningGroup.departments)
        if (selectedPlanningGroup) {
          filteredPlanningGroup.push(selectedPlanningGroup)
        }
        return filteredPlanningGroup
      } else {
        return this.allPlanningGroupList
      }
    },

    planningGroupList (): Array<QcqShiftPlanningGroup> | undefined {
      if (this.formData) {
        return this.formData.planningGroupList
      } else {
        return undefined
      }
    },

    breakList (): Array<ShiftBreak> | undefined {
      if (this.formData) {
        return this.formData.shiftBreakList
      } else {
        return undefined
      }
    },

    competencesList (): Array<QcqShiftCompetences> | undefined {
      if (this.formData && this.selectedAddedPlanningGroup) {
        return this.formData.competences.filter(
          (item: QcqShiftCompetences) => item.planningGroup === this.selectedAddedPlanningGroup.planningGroup)
      } else {
        return []
      }
    },

    isActiveDisabled (): boolean {
      if(this.action === MasterDataActionsEnum.Create) {
        return true
      } else {
        return false
      }
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    }
  },

  watch: { },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onAddBreakClick (): void {
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
      this.breakDialogTitle = this.$t('masterData.shifts.addBreak').toString()
      this.showBreakDialog = true
    },

    onBreakRowClicked (params: any): void {
      this.currentSelectedBreakId = params.node.data.id
      this.selectedBreakData = params.data


    },

    onEditBreakClick (): void {
      this.breakDialogTitle = this.$t('masterData.shifts.editBreak').toString()
      this.showBreakDialog = true
    },

    onDeleteBreakClick (): void {
      this.showDeleteBreakDialog = true
    },

    onDeleteBreakDialogClose (): void {
      this.showDeleteBreakDialog = false
    },

    deleteBreak (): void {
      if(this.formData && this.formData.shiftBreakList && this.selectedBreakData) {
        let index: number = this.formData.shiftBreakList.indexOf(this.selectedBreakData)
        this.formData.shiftBreakList.splice(index, 1)
      }
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
      this.showDeleteBreakDialog = false
    },

    onBreakDialogClose (): void {
      this.showBreakDialog = false
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
    },

    onCreateNewBreak (data: ShiftBreakPayload): void {
      let maxId: ShiftBreak | undefined = _.maxBy(this.breakList, 'id')
      if(this.formData) {
        this.formData.shiftBreakList.push(
            ShiftBreak.create(
                maxId ? maxId.id + 1 : 1,
                this.formData.id ? this.formData.id.toString() : '',
                data.startBreak,
                data.endBreak,
                data.duration,
                data.deductionCapacity,
                data.comment)
        )
      }
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
      this.showBreakDialog = false
    },

    onEditBreak (data: ShiftBreakPayload): void {
      if(this.formData && this.formData.shiftBreakList && this.selectedBreakData && this.currentSelectedBreakId) {
        let index: number = this.formData.shiftBreakList.indexOf(this.selectedBreakData)
        this.formData.shiftBreakList.splice(index, 1, ShiftBreak.create(
            parseInt(this.currentSelectedBreakId),
            this.formData.id ? this.formData.id.toString() : '',
            data.startBreak,
            data.endBreak,
            data.duration,
            data.deductionCapacity,
            data.comment)
        )
      }
      this.currentSelectedBreakId = undefined
      this.selectedBreakData = undefined
      this.showBreakDialog = false
    },

    onAddPlanningGroupClick (): void {
      this.planningGroupDialogTitle = this.$t('masterData.shifts.addNewFreeShiftPlanningGroup').toString()
      this.showPlanningGroupDialog = true
      this.planningGroupAction = QcqOperations.ADD
      if (this.formData && this.selectedDepartmentId) {
        const foundItem: Department | undefined = _.find(this.departmentList, { id: this.selectedDepartmentId })
        if (foundItem) {
          this.selectedAddedPlanningGroup = new QcqShiftPlanningGroup(
            this.formData.id,
            undefined,
            1,
            '',
            this.selectedDepartmentId,
            undefined,
            foundItem.label,
            '',
            '00:00'
          )
        }
      }
    },

    onEditPlanningGroupClick (): void {
      if (this.formData) {
        this.selectedAddedPlanningGroup = this.formData.planningGroupList.find((item: QcqShiftPlanningGroup) =>
          item.planningGroup === parseInt(this.currentSelectedPlanningGroupId))
      }
      this.planningGroupDialogTitle = this.$t('masterData.shifts.editFreeShiftPlanningGroup').toString()
      this.showPlanningGroupDialog = true
      this.planningGroupAction = QcqOperations.EDIT
    },

    onDeletePlanningGroupClick (): void {
      this.showDeletePlanningGroupDialog = true
    },

    deletePlanningGroup () {
      if (this.formData) {
        this.selectedAddedPlanningGroup = this.formData.planningGroupList.find((item: QcqShiftPlanningGroup) =>
          item.planningGroup === parseInt(this.currentSelectedPlanningGroupId))

        let foundItems: Array<QcqShiftCompetences> = this.formData.competences.filter(
          (item: QcqShiftCompetences) => this.formData && item.planningGroup === this.selectedAddedPlanningGroup.planningGroup)
        this.formData.competences = (_.difference(this.formData.competences, foundItems))
        let index: number = this.formData.planningGroupList.indexOf(this.selectedAddedPlanningGroup)
        this.formData.planningGroupList.splice(index, 1)
      }
      this.showDeletePlanningGroupDialog = false
      this.currentSelectedPlanningGroupId = ''
    },

    onDeletePlanningGroupDialogClose (): void {
      this.showDeletePlanningGroupDialog = false
    },

    onAddOffsetClick (): void {
      this.offsetAction = undefined
      this.selectedAddedOffset = undefined
      this.showOffsetDialog = true
    },

    onEditOffsetClick (): void {
      if (this.selectedAddedOffset) {
        this.offsetAction = QcqOperations.EDIT
        this.showOffsetDialog = true
      }
    },

    onDeleteOffsetClick (): void {
      this.showDeleteOffsetDialog = true
    },

    deleteOffset () {
      if (this.formData && this.selectedAddedOffset) {
        let index: number = this.formData.competences.indexOf(this.selectedAddedOffset)
        this.formData.competences.splice(index, 1)
      }

      this.showDeleteOffsetDialog = false
      this.isEnableOffsetButtons = false
      this.selectedAddedOffset = undefined
    },

    onDeleteOffsetDialogClose (): void {
      this.showDeleteOffsetDialog = false
    },

    onPlanningGroupRowClicked (params: any): void {
      this.currentSelectedPlanningGroupId = params.node.data.planningGroup
      this.selectedAddedPlanningGroup = params.data
      this.isEnableOffsetButtons = false
    },

    onOffsetRowClicked (params: any): void {
      this.selectedAddedOffset = params.data
      this.isEnableOffsetButtons = true
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        if (this.formData && this.formData.planningGroupList.length > 0) {
          this.$emit('save', this.formData)
        } else {
          this.errorMessage = this.$t('masterData.shifts.withoutPlanningGroupTheDepartmentWillNotBeSaved').toString()
          this.showErrorSnackbar = true
        }
      } else {
        this.errorMessage = this.$t('masterData.shifts.incorrectlyFilledOutForm').toString()
        this.showErrorSnackbar = true
      }
    },

    resetForm () {
      const form: any = this.$refs['form']
      if(form) {
        form.resetValidation()
      }
      this.currentSelectedPlanningGroupId = ''
      this.isEnableOffsetButtons = false

      if (this.dialogData) {
        this.formData = _.cloneDeep(this.dialogData)
      } else {
        this.formData = new QcqShift(
          undefined,
          '',
          '',
          '00:00',
          '00:00',
          0,
          '#fff',
          [],
          [],
          true,
          []
        )
      }
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onPlanningGroupDialogClose (): void {
      this.showPlanningGroupDialog = false
    },

    onCreateNewPlanningGroup (payload: QcqShiftPlanningGroup): void {
      if (this.formData) {
        if (this.planningGroupAction === QcqOperations.ADD) {
          this.formData.planningGroupList.push(payload)
        }
        if (this.planningGroupAction === QcqOperations.EDIT) {
          let foundItem: QcqShiftPlanningGroup | undefined = this.formData.planningGroupList.find((item: QcqShiftPlanningGroup) =>
            item.planningGroup === this.selectedAddedPlanningGroup.planningGroup
          )

          let foundOffset: Array<QcqShiftCompetences> = this.formData.competences.filter(
            (item: QcqShiftCompetences) => this.formData && item.planningGroup === this.selectedAddedPlanningGroup.planningGroup)

          foundOffset.forEach((item: QcqShiftCompetences) => {item.planningGroup = payload.planningGroup})

          if (foundItem) {
            this.formData.planningGroupList.splice(this.formData.planningGroupList.indexOf(foundItem), 1, payload)
          }
        }
      }
      this.showPlanningGroupDialog = false
      this.currentSelectedPlanningGroupId = ''
    },

    onOffsetDialogClose (): void {
      this.showOffsetDialog = false
      this.offsetAction = undefined
    },

    onCreateNewOffset (payload: QcqShiftCompetences): void {
      if (this.formData) {
        if(!this.offsetAction || this.offsetAction !== QcqOperations.EDIT) {
          payload.shiftId = this.formData.id
          payload.planningGroupId = this.selectedAddedPlanningGroup.planningGroupId
          payload.departments = this.selectedDepartmentId
          payload.planningGroup = this.selectedAddedPlanningGroup.planningGroup
          this.formData.competences.push(payload)
        } else {
          this.formData.competences.splice(this.formData.competences.indexOf(this.selectedAddedOffset!), 1, payload)
        }
      }
      this.offsetAction = undefined
      this.showOffsetDialog = false
    },

    onColorChange (color: Color): void {
      if (color && color.hex) {
        if (this.formData) {
          this.formData.color = color.hex
        }
      }
    },

  },

  created () {
    this.resetForm()
    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }

})
